import { render, staticRenderFns } from "./curvefit.vue?vue&type=template&id=6fc20054&"
import script from "./curvefit.vue?vue&type=script&lang=js&"
export * from "./curvefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports